import { render, staticRenderFns } from "./ZoomImage.vue?vue&type=template&id=4cb16c0e&scoped=true&"
import script from "./ZoomImage.vue?vue&type=script&lang=ts&"
export * from "./ZoomImage.vue?vue&type=script&lang=ts&"
import style0 from "./ZoomImage.vue?vue&type=style&index=0&id=4cb16c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb16c0e",
  null
  
)

export default component.exports